import { render, staticRenderFns } from "./TimeTopic.vue?vue&type=template&id=34217e8d&scoped=true&"
import script from "./TimeTopic.vue?vue&type=script&lang=js&"
export * from "./TimeTopic.vue?vue&type=script&lang=js&"
import style0 from "./TimeTopic.vue?vue&type=style&index=0&id=34217e8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34217e8d",
  null
  
)

export default component.exports